import { render, staticRenderFns } from "./configFav.vue?vue&type=template&id=71f64476&"
import script from "./configFav.vue?vue&type=script&lang=ts&"
export * from "./configFav.vue?vue&type=script&lang=ts&"
import style0 from "./configFav.vue?vue&type=style&index=0&id=71f64476&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports